import React, { useState } from "react";
import { Card, BlockStack, InlineStack, Text, Button, DataTable, Divider } from "@shopify/polaris";
import { OTHER_APPS } from "../../helper/huptechApps";

// Dismissing hides the section for 30 days (per browser), then it returns.
const DISMISS_KEY = "hw_recommended_apps_dismissed_at";
const DISMISS_MS = 30 * 24 * 60 * 60 * 1000;

const isDismissed = () => {
    try {
        const t = parseInt(window.localStorage.getItem(DISMISS_KEY) || "0", 10);
        return !!t && Date.now() - t < DISMISS_MS;
    } catch (e) {
        return false;
    }
};

function RecLogo({ app }) {
    if (app.logo) {
        return <img className="hw-rec-logo" src={app.logo} alt={`${app.name} logo`} />;
    }
    return (
        <div className="hw-rec-logo hw-rec-logo-fallback" style={{ background: app.accent || "#1a1a1a" }} aria-hidden="true">
            {app.short || (app.name || "?").slice(0, 1)}
        </div>
    );
}

/*
 * "Recommended apps" cross-sell at the bottom of the Analytics dashboard, shown
 * as a dismissible boxed table. The merchant can close it with the X; it then
 * stays hidden for 30 days (stored per browser) and reappears afterwards.
 */
function RecommendedApps() {
    const [hidden, setHidden] = useState(isDismissed);
    if (!OTHER_APPS.length || hidden) return null;

    const dismiss = () => {
        try { window.localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch (e) { /* noop */ }
        setHidden(true);
    };

    const rows = OTHER_APPS.map((app) => [
        (
            <InlineStack gap="300" blockAlign="center" wrap={false}>
                <RecLogo app={app} />
                <Text as="span" variant="bodyMd" fontWeight="semibold">{app.name}</Text>
            </InlineStack>
        ),
        <Text as="span" variant="bodySm" tone="subdued">{app.description}</Text>,
        (
            <span className="hw-app-pbtn">
                <Button variant="primary" url={app.url} external>Install now</Button>
            </span>
        ),
    ]);

    return (
        <Card>
            <BlockStack gap="300">
                <InlineStack align="space-between" blockAlign="start" wrap={false} gap="200">
                    <BlockStack gap="050">
                        <Text as="h2" variant="headingMd">Recommended apps</Text>
                        <Text as="span" variant="bodySm" tone="subdued">More tools from Huptech Web to grow your store</Text>
                    </BlockStack>
                    <button type="button" className="hw-rec-close" aria-label="Dismiss recommended apps" onClick={dismiss}>✕</button>
                </InlineStack>
                <Divider />
                <DataTable
                    columnContentTypes={["text", "text", "text"]}
                    headings={["App", "Description", ""]}
                    rows={rows}
                    verticalAlign="middle"
                />
            </BlockStack>
        </Card>
    );
}

export default RecommendedApps;
